import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Table } from "antd";
import { FileSearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import logsHistoryActions from "../../../redux/logsHistory/actions";
import { useProjectState } from "../../../context/stateContext";
import AdminLogsMessageModal from "./AdminLogsMessageModal";

const { getLogsRequest } = logsHistoryActions;

const AdminLogsHistoryTable = ({ logHistoryData, searchedLogsHistory }) => {
  const dispatch = useDispatch();
  const [openLogsMessageModal, setOpenLogsMessageModal] = useState(false);
  const [logRecord, setLogRecord] = useState({});
  const { startDate, endDate } = useProjectState();

  useEffect(() => {
    dispatch(getLogsRequest(startDate, endDate));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const filterFunctionalityTransformArray = (array, objProperty) => {
    const uniqueValuesArray = array.map(
      (item) =>
        item[objProperty] !== null &&
        item[objProperty] !== false && {
          value: item[objProperty],
          text: item[objProperty],
        }
    );

    const result = Object.values(
      uniqueValuesArray.reduce((acc, obj) => ({ ...acc, [obj.value]: obj }), {})
    ).filter((item) => item !== false);
    return result;
  };

  const informationLogsFilter = logHistoryData
    ?.map((log) => log.message)
    ?.filter((value, index, array) => {
      return array.indexOf(value) === index;
    })
    ?.map((name) => {
      return {
        text: name,
        value: name,
      };
    });

  const columns = [
    {
      title: "Дата",
      dataIndex: "time",
      rowKey: "time",
      width: "10%",
      render: (text) => <span>{dayjs(text).format("HH:mm:ss / DD-MM")}</span>,
    },
    {
      title: "Организация",
      dataIndex: "organizationName",
      rowKey: "organizationName",
      width: "15%",
      render: (text) => <span>{text}</span>,
      filters: filterFunctionalityTransformArray(
        searchedLogsHistory === null ? logHistoryData : searchedLogsHistory,
        "organizationName"
      ),
      filterSearch: true,
      onFilter: (value, record) =>
        record.organizationName !== null &&
        record.organizationName.includes(value),
    },
    {
      title: "Име",
      dataIndex: "userFullName",
      rowKey: "userFullName",
      width: "15%",
      render: (text) => <span>{text}</span>,
      filters: filterFunctionalityTransformArray(
        searchedLogsHistory === null ? logHistoryData : searchedLogsHistory,
        "userFullName"
      ),
      filterSearch: true,
      onFilter: (value, record) =>
        record.userFullName !== null && record.userFullName.includes(value),
    },
    {
      title: "Имейл",
      dataIndex: "userEmail",
      rowKey: "userEmail",
      width: "15%",
    },
    {
      title: "Събития",
      dataIndex: "message",
      rowKey: "message",
      width: "25%",
      filters: informationLogsFilter,
      filterSearch: true,
      onFilter: (value, record) => record?.message?.startsWith(value),
    },

    {
      title: "Информация",
      dataIndex: "data",
      rowKey: "data",
      width: "10%",
      render: (text, record) => (
        <div
          className="admin-logs-table-information-column"
          onClick={() => {
            setLogRecord(record);
            setOpenLogsMessageModal(true);
          }}
        >
          <p>
            Виж <FileSearchOutlined />
          </p>
        </div>
      ),
    },
  ];

  return (
    <>
      <AdminLogsMessageModal
        openLogsMessageModal={openLogsMessageModal}
        setOpenLogsMessageModal={setOpenLogsMessageModal}
        logRecord={logRecord}
      />
      <Table
        className="admin-logs-history-table"
        loading={logHistoryData?.length === 0}
        columns={columns}
        dataSource={
          searchedLogsHistory === null ? logHistoryData : searchedLogsHistory
        }
      />
    </>
  );
};

export default AdminLogsHistoryTable;
